<ng-container *ngIf="hideScheduledTable$ | async; else scheduledTable">
  <div class="mt--100 block ta--center" *ngIf="{ value: hasError$ | async } as hasError">
    <h3 class="mt--250">
      {{ !hasError.value ? 'No autopay set up yet' : 'Sorry, Scheduled Payments cannot be displayed right now.' }}
    </h3>
    <div class="p mt--050 mb--250">
      {{ !hasError.value ? 'Set up autopay for invoices in the Settings page.' : 'Please check back again soon.' }}
    </div>
  </div>
</ng-container>

<ng-template #scheduledTable>
  <div class="mt--100 data-table">
    <div class="data-table__head">
      <div class="grid-row grid-row--aic">
        <div class="grid-col">
          <h3>Scheduled</h3>
        </div>

        <div class="grid-col grid-col--auto">
          <select class="form-select" (change)=shownTimeSelectionChanged($event.target.value) data-cy="scheduled-time-options-dropdown">
            <option *ngFor="let selectedTimeframe of shownTimeSelectionOptions">{{selectedTimeframe}}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="data-table__cont">
      <table mat-table matSort matSortActive="date"
        [dataSource]="scheduledPaymentService.dataSourceScheduledPayments"
        matSortDirection="asc" class="data-table__tbl">

        <!--Date-->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let scheduledPayment" data-cy="scheduled-payment-date">
            {{scheduledPayment.actionDefInstanceStaged.scheduledReleaseDate | date: 'MM/dd/yy'}}
          </td>
        </ng-container>

        <!--Client (account)-->
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
          <td mat-cell *matCellDef="let scheduledPayment" data-cy="scheduled-payment-account">
            {{scheduledPayment.client.name}}
          </td>
        </ng-container>

        <!--Method-->
        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Method
          </th>
          <td mat-cell *matCellDef="let scheduledPayment" class="tt--capitalize" data-cy="scheduled-payment-method">
            <div *ngIf="scheduledPaymentProcessingComplete && !scheduledPayment.isPaymentMethodFromUser; then thenBlock else elseBlock"></div>

            <!--Renders when the payment method is not owned by the current user-->
            <ng-template #thenBlock>
              <!--Renders if payment method is ACH-->
              <span *ngIf="isDirectDebit(scheduledPayment.actionDefInstanceDTO.action.paymentMethod); else card">
                <img src="assets/payment-methods/union.svg" width="20" height="20" alt="" class="data-table__payment-icon">

                {{ scheduledPayment.actionDefInstanceDTO.action.paymentMethod | uppercase }}
                Bank Transfer ••••{{scheduledPayment.actionDefInstanceDTO.action.last4}}

                <button (click)="launchPaymentMethodIsNotFromUserInfoModal()">
                  <div class="badge--primary">
                    <svg width="12" height="20" viewBox="0 0 16 16" fill="currentColor" class="inline-icon">
                      <path
                        d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z"
                      ></path>
                      <rect x="7" y="7" width="2" height="5"></rect>
                      <circle cx="8" cy="5" r="1"></circle>
                    </svg>
                  </div>
                </button>
              </span>

              <!--Renders if payment method is CREDIT or DEBIT-->
              <ng-template #card>
                <img
                  src="assets/payment-methods/{{scheduledPayment.actionDefInstanceDTO.action.cardType}}.svg"
                  width="20" height="20" alt="" class="data-table__payment-icon"
                >

                {{scheduledPayment.actionDefInstanceDTO.action.cardType}}
                ••••{{scheduledPayment.actionDefInstanceDTO.action.last4}}

                <button (click)="launchPaymentMethodIsNotFromUserInfoModal()">
                  <div class="badge--primary">
                    <svg width="12" height="20" viewBox="0 0 16 16" fill="currentColor" class="inline-icon">
                      <path
                        d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S11.3,14,8,14z"
                      ></path>
                      <rect x="7" y="7" width="2" height="5"></rect>
                      <circle cx="8" cy="5" r="1"></circle>
                    </svg>
                  </div>
                </button>
              </ng-template>
            </ng-template>

            <!--Renders when the payment method is owned by the current user-->
            <ng-template #elseBlock>
              <!--Renders if payment method is ACH-->
              <span *ngIf="isDirectDebit(scheduledPayment.actionDefInstanceDTO.action.paymentMethod); else card">
                <img src="assets/payment-methods/union.svg" width="20" height="20" alt="" class="data-table__payment-icon">

                {{ scheduledPayment.actionDefInstanceDTO.action.paymentMethod | uppercase }}
                Bank Transfer ••••{{scheduledPayment.actionDefInstanceDTO.action.last4}}
              </span>

              <!--Renders if payment method is CREDIT or DEBIT-->
              <ng-template #card>
                <img
                  src="assets/payment-methods/{{scheduledPayment.actionDefInstanceDTO.action.cardType}}.svg"
                  width="20" height="20" alt="" class="data-table__payment-icon"
                >

                {{scheduledPayment.actionDefInstanceDTO.action.cardType}}
                ••••{{scheduledPayment.actionDefInstanceDTO.action.last4}}
              </ng-template>
            </ng-template>
          </td>
        </ng-container>

        <!--Amount-->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
          <td mat-cell *matCellDef="let scheduledPayment" data-cy="scheduled-payment-amount">
            <ng-container *ngIf="scheduledPayment.getAmountDisplay() !== 'Pending'; else pendingAmount">
              {{
              scheduledPayment.getAmountDisplay(
                configService.paymentPlanProcessingFeeRate,
                configService.internationalCardFeeRate,
                configService.firmCountry
              ) | currency
              }}
            </ng-container>

            <ng-template #pendingAmount>
              {{scheduledPayment.getAmountDisplay()}}
            </ng-template>
          </td>
        </ng-container>

        <!--Status-->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let scheduledPayment" data-cy="scheduled-payment-status">
            <div *ngIf="scheduledPayment.actionDefInstanceDTO.status === 'DECLINED'">
              <div class="badge badge--warning">
                <div class="badge__label">Skipped</div>
              </div>
            </div>
            <div *ngIf="scheduledPayment.actionDefInstanceDTO.status === 'STAGED'">
              <div class="badge">
                <div class="badge__label">Scheduled</div>
              </div>
            </div>
          </td>
        </ng-container>


        <!--Recurring payment-->
        <ng-container matColumnDef="paymentPlan">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let scheduledPayment" data-cy="scheduled-payment-recurring-payment-name">
            <ng-container *ngIf="scheduledPayment.showMaximumAmount(); else noMaxAmount">
              {{ scheduledPayment.getDisplayName() }}{{ scheduledPayment.getMaximumAmount() | currency }}
            </ng-container>
            <ng-template #noMaxAmount>
              {{scheduledPayment.getDisplayName()}}
            </ng-template>
          </td>
        </ng-container>

        <!--Menu Button-->
        <ng-container matColumnDef="scheduledPaymentMenu">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let scheduledPayment" class="width--1" (click)="$event.stopPropagation()">
            @let menuEnabled = scheduledPayment.canEdit() || scheduledPayment.canNavigateToDetailedPage();

            <div tooltip="No actions available" [tooltipEnabled]="!menuEnabled">

              <button
                type="button"
                class="button button--sm data-table__more"
                [matMenuTriggerFor]="menu"
                [disabled]="!menuEnabled"
              >
                <svg width="16px" height="16px" viewBox="0 0 16 16" class="button__icon" data-cy="scheduled-menu">
                  <circle fill="currentColor" cx="8" cy="8" r="2"></circle>
                  <circle fill="currentColor" cx="2" cy="8" r="2"></circle>
                  <circle fill="currentColor" cx="14" cy="8" r="2"></circle>
                </svg>
              </button>
            </div>

            <mat-menu #menu="matMenu" xPosition="before">
              @if (scheduledPayment.canNavigateToDetailedPage()) {
                <button mat-menu-item (click)="scheduledPayment.navigateToPage(router)" data-cy="navigate-to-scheduled-payments-detail">
                  {{ scheduledPayment.getNavigationMessage() }}
                </button>
              }

              @if (scheduledPayment.canEdit()) {
                @if (scheduledPayment.actionDefInstanceDTO.status === 'STAGED') {
                  <button mat-menu-item (click)="skipScheduledPayment(scheduledPayment)" data-cy="skip-payment">
                    Skip
                  </button>
                } @else {
                  <button mat-menu-item (click)="resumeScheduledPayment(scheduledPayment)" data-cy="resume-payment">
                    Resume
                  </button>
                }
              }
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="data-table__row"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay"
          class="data-table__row data-table__row--selectable"></tr>
      </table>
    </div>
    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true" class="legacy-layout"></mat-paginator>
  </div>
</ng-template>

<!--<div *ngIf="!hideScheduledTable && configService.isMobile">-->
<!--  <div class="mt&#45;&#45;200 grid-row grid-row&#45;&#45;aic">-->
<!--    <div class="grid-col">-->
<!--      <h3>Scheduled</h3>-->
<!--    </div>-->
<!--  </div>-->

<!--  <div class="mt&#45;&#45;075" *ngFor="let scheduledPaymentTableObject of scheduledPaymentsService.dataSourceScheduledPayments.data;">-->
<!--    <app-scheduled-table-card [scheduledPaymentTableObject]="scheduledPaymentTableObject"></app-scheduled-table-card>-->
<!--  </div>-->
<!--</div>-->

<!--<div class="mt&#45;&#45;100 block ta&#45;&#45;center" *ngIf="scheduledPaymentsService.dataSourceScheduledPayments.data.length === 0 && configService.viewPastPaymentsEnabled">-->
<!--  <h3 class="mt&#45;&#45;250">You don't have any scheduled payments</h3>-->
<!--</div>-->

<!--<div *ngIf="scheduledPaymentsService.dataSourceScheduledPayments.data.length === 0 && !configService.viewPastPaymentsEnabled">-->
<!--  <app-empty-page [title]="emptyPageService.invoiceTitle" [text]="emptyPageService.invoiceText"></app-empty-page>-->
<!--</div>-->
